// extracted by mini-css-extract-plugin
module.exports = {"container":"UserModale_container__1FjsD","actions":"UserModale_actions__3LIvS"};